import initialState from 'redux/initial-states/gimac';
import getActivitySectorList from './getActivitySectorList';

export default (state = initialState, action = {}) => ({
    ...state,
    ...getActivitySectorList(state, action),
  });
  